import React, { useState, useEffect } from "react";
import { Typography, Container } from "@mui/material";

import "./Dolar3d.css";

const estiloDolar = {
  fontSize: "1em",
  textAlign: "center",
  padding: "20px",
  backgroundColor: "#212121",
  borderRadius: "8px",
  boxShadow: "0 0 10px rgba(0, 0, 150, 0.1)",
  color: "white",
  marginBottom: "30px",
};

function DatosDesdeAPI() {
  const [datos, setDatos] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [ultimaActualizacion, setUltimaActualizacion] = useState(null);

  const fetchData = async () => {
    try {
      const response = await fetch("https://dolarapi.com/v1/dolares");
      const data = await response.json();
      setUltimaActualizacion(new Date());
      setDatos(data);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();

    // Configura un intervalo para actualizar los datos cada minuto
    const intervalId = setInterval(() => {
      fetchData();
    }, 60000); // 60000 milisegundos = 1 minuto

    // Limpia el intervalo al desmontar el componente
    return () => clearInterval(intervalId);
  }, []); // El segundo argumento del useEffect es un array vacío para que se ejecute solo una vez al montar el componente

  if (loading) {
    return <p>Cargando...</p>;
  }

  if (error) {
    return <p>Error al cargar los datos: {error.message}</p>;
  }

  if (!datos) {
    return null;
  }

  return (
    <div>
      <div style={estiloDolar}>
        <h3 class="Subtitulo">Valor del Dolar en tiempo Real</h3>

        <div class="cube-container">
          <div class="cube">
            <div class="face front">
              <div class="DolarBlue">
                Dolar {datos[0].casa}
                <div class="venta">Venta: $ {datos[0].venta}</div>
              </div>
            </div>

            <div class="face back">
              <div class="DolarBlue">
                Dolar {datos[5].casa}
                <div class="venta">Venta: $ {datos[5].venta}</div>
              </div>
            </div>
            <div class="face right">
              <div class="DolarBlue">
                Dolar {datos[2].casa}
                <div class="venta">Venta: $ {datos[2].venta}</div>
              </div>
            </div>

            <div class="face left">
              <div class="DolarBlue">
                Dolar {datos[3].casa}
                <div class="venta">Venta: $ {datos[3].venta}</div>
              </div>
            </div>
            <div class="face top">
              <div class="DolarBlue">
                Dolar {datos[4].casa}
                <div class="venta">Venta: $ {datos[4].venta}</div>
              </div>
            </div>
            <div class="face bottom">
              <div class="DolarBlue">
                Dolar {datos[1].casa}
                <div class="venta">Venta: $ {datos[1].venta}</div>
              </div>
            </div>
          </div>
        </div>

        <h3>
          Última actualización: {ultimaActualizacion.toLocaleTimeString()}{" "}
          <Container>
            <Typography variant="h6" mt={4} mb={4}>
              Fernando Aguirre
            </Typography>
            <Typography variant="h6">
              Datos obtenidos desde{" "}
              <a href="https://www.dolarapi.com" target="_blank">
                {" "}
                dolarapi.com
              </a>
            </Typography>
          </Container>
        </h3>
      </div>
    </div>
  );
}

export default DatosDesdeAPI;
